import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import store from './store'
import mitt from 'mitt'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { Search, Bell, Tickets, Calendar, Close, Star, Share, Document, 
    Setting, Menu, Location, Avatar, Help, InfoFilled, Cpu, Operation, PieChart, Switch, Pointer, Tools, 
    ShoppingCart, Refresh, Back, House, Plus, Select, Coin, DataLine, DataAnalysis, EditPen, Crop, Cherry, Connection, Money, Compass } from '@element-plus/icons-vue'

const app = createApp(App)
app.use(ElementPlus)
app.use(store)
app.use(router)
app.use(createPinia())
app.component('search', Search)
app.component('bell', Bell)
app.component('tickets', Tickets)
app.component('calendar', Calendar)
app.component('close', Close)
app.component('star', Star)
app.component('share', Share)
app.component('document', Document)
app.component('setting', Setting)
app.component('menu', Menu)
app.component('location', Location)
app.component('avatar', Avatar)
app.component('help', Help)
app.component('InfoFilled', InfoFilled)
app.component('cpu', Cpu)
app.component('operation', Operation)
app.component('pieChart', PieChart)
app.component('Switch', Switch)
app.component('pointer', Pointer)
app.component('tools', Tools)
app.component('shoppingCart', ShoppingCart)
app.component('refresh', Refresh)
app.component('back', Back)
app.component('house', House)
app.component('plus', Plus)
app.component('select', Select)
app.component('coin', Coin)
app.component('dataLine', DataLine)
app.component('dataAnalysis', DataAnalysis)
app.component('editPen', EditPen)
app.component('crop', Crop)
app.component('cherry', Cherry)
app.component('connection', Connection)
app.component('money', Money)
app.component('compass', Compass)
app.mount('#app')

app.config.globalProperties.vueEvent = new mitt()

router.afterEach((to,from,next) => {
    window.scrollTo(0, 0)
})
